import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { generateRandomString } from '@fc-shared/utils/data.utils';
import { MatRipple } from '@angular/material/core';

@Component({
  selector: 'fc-checkbox',
  template: `
    <div
      class="relative flex h-40 w-40 flex-col items-center justify-center rounded-full"
      matRipple
      (click)="$event.stopPropagation()"
    >
      <input
        (change)="onChange($event)"
        [id]="id"
        type="checkbox"
        [checked]="checked()"
        [disabled]="disabled()"
        [indeterminate]="indeterminate()"
        class="absolute z-[2] h-full w-full cursor-pointer opacity-0"
      />
      <div
        class="flex h-18 w-18 items-center justify-center rounded border"
        [class.border-secondary-400]="!checked() && !indeterminate()"
        [class.border-primary-500]="checked() || indeterminate()"
        [class.bg-primary-500]="checked() || indeterminate()"
        [class.opacity-50]="disabled()"
        [class.pointer-events-none]="disabled()"
      >
        @if (checked() && !indeterminate()) {
          <fc-icon icon="icon-tick" color="white" [size]="16" />
        }
        @if (indeterminate()) {
          <fc-icon icon="icon-remove" color="white" [size]="16" />
        }
      </div>
    </div>
    <label [for]="id" class="cursor-pointer pl-4 text-sm text-grey-900">
      <ng-content></ng-content>
    </label>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, MatRipple],
  host: {
    class: 'flex items-center',
    '[class.disabled]': 'disabled()',
  },
})
export class Checkbox {
  id = generateRandomString(4);
  checked = model<boolean>(false);
  indeterminate = input<boolean>(false);
  disabled = input<boolean>(false);

  onChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.checked.set(isChecked);
  }
}
